// extracted by mini-css-extract-plugin
module.exports = {"label":"Navbar_label__2vojo","fontpaddingfornavbar":"Navbar_fontpaddingfornavbar__B9kfl"};